import { MenuItem } from './menu.model';

// Favor de actualizar
// CurrentId: 60 Recompensas Maltia / Dotaciones

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true,
  },
  {
    id: 100,
    label: 'CTC',
    icon: 'bx-user',
    permissionRequired: 'show.CTC',
    subItems: [
      {
        id: 101,
        label: 'Clasificación',
        link: '/ctc/client-classification',
        parentId: 100,
        permissionRequired: 'show.clasification',
      },
      {
        id: 102,
        label: 'Matriz de clientes',
        link: '/ctc/customer-matrix',
        parentId: 100,
        permissionRequired: 'show.customerMatrix',
      },
      {
        id: 103,
        label: 'Datos de contacto',
        link: '/ctc/customer-contact-information',
        parentId: 100,
        permissionRequired: 'show.customerContactInformation',
      },
      {
        id: 104,
        label: 'Histórico de observaciones',
        link: '/ctc/customer-observations-history',
        parentId: 100,
        permissionRequired: 'show.CTC.ObservationsHistory',
      },
    ],
  },
  {
    id: 200,
    label: 'Notificaciones',
    icon: 'bx-message',
    permissionRequired: 'show.Notifications',
    subItems: [
      {
        id: 201,
        label: 'WhatsApp',
        link: '/notifications/whatsapp',
        parentId: 200,
        permissionRequired: 'show.NotificationsWhatsApp',
      },
      {
        id: 202,
        label: 'Push',
        link: '/notifications/pushNotifications',
        parent: 200,
        permissionRequired: 'show.pushNotifications',
      },
    ],
  },
  {
    id: 300,
    label: 'Generador Ref.',
    icon: 'bx-barcode',
    permissionRequired: 'show.GeneradorReferencia',
    subItems: [
      {
        id: 301,
        label: 'Nueva referencia',
        link: '/reference/new',
        parentId: 300,
      },
    ],
  },
  {
    id: 400,
    label: 'Solicitudes de crédito',
    icon: 'bx-file',
    permissionRequired: 'show.SolicitudesCredito',
    subItems: [
      {
        id: 401,
        label: 'Portal',
        link: '/source-portal/list',
        parentId: 400,
        permissionRequired: 'show.ListProspectsPortal',
      },
      {
        id: 402,
        label: 'Whitelist',
        link: '/source-portal/white-list',
        parentId: 400,
        permissionRequired: 'show.whiteListPortal',
      },
      {
        id: 403,
        label: 'Listado',
        link: '/credit-request/list',
        parentId: 400,
      },
      {
        id: 404,
        label: 'Histórico de folios',
        link: 'prospect/folio-history',
        parentId: 400,
        permissionRequired: 'show.folioHistory',
      },
    ],
  },
  {
    id: 500,
    label: 'Mesa control',
    icon: 'bx-list-check',
    permissionRequired: 'show.SolicitudesMesaControl',
    subItems: [
      {
        id: 501,
        label: 'Adm. Cuentas bancarias',
        icon: 'bx-list-check',
        link: '/bank-account-management/list',
        permissionRequired: 'show.bankAccountManagament',
        parentId: 500,
      },
      {
        id: 502,
        label: 'Solicitudes de crédito',
        icon: 'bx-list-check',
        link: '/prospect/listTableControl',
        permissionRequired: 'show.accountCheckList',
        parentId: 500,
      },
      {
        id: 503,
        label: 'Solicitudes canceladas',
        icon: 'bx-list-check',
        link: '/prospect/cancelled-credit-applications',
        permissionRequired: 'show.SolicitudesCanceladas',
        parentId: 500,
      },
      {
        id: 504,
        label: 'Solicitudes de dispersión',
        icon: 'bx-list-check',
        link: '/dispersions-requests/list',
        permissionRequired: 'show.dispersionsMC',
        parentId: 500,
      },
    ],
  },
  {
    id: 600,
    label: 'Visita Fisíca',
    icon: 'bx-user-voice',
    permissionRequired: 'show.physicalVisit',
    subItems: [
      {
        id: 601,
        label: 'Catálogos',
        link: '/physical-visit/catalogs',
        permissionRequired: 'show.PhysicalVisitCatalog',
        parentId: 600,
      },
      {
        id: 602,
        label: 'Torre de Control',
        link: '/physical-visit/control-tower',
        permissionRequired: 'show.PhysicalVisitControlTower',
        parentId: 600,
      },
    ],
  },
  {
    id: 700,
    label: 'Asesores en sucursal',
    icon: 'bx-map',
    permissionRequired: 'show.AsesoresEnSucursal',
    subItems: [
      {
        id: 701,
        label: 'Monitor de ubicaciones',
        link: '/maps/users-locations',
        parentId: 700,
      },
    ],
  },
  {
    id: 800,
    label: 'Gestión de cartera',
    icon: 'bx-wallet-alt',
    permissionRequired: 'show.GestionCartera',
    subItems: [
      {
        id: 801,
        label: 'Administración de gestores',
        link: '/manager/list',
        parentId: 800,
        permissionRequired: 'show.AdminGestores',
      },
      {
        id: 802,
        label: 'Administración de gerentes',
        link: '/portfolio-management/list-managers',
        parentId: 800,
        permissionRequired: 'show.AdminGerentes',
      },
      {
        id: 803,
        label: 'Administración de promotores',
        link: '/portfolio-management/list-promoters',
        parentId: 800,
        permissionRequired: 'show.AdminPromotores',
      },
      {
        id: 804,
        label: 'Administración de cartera',
        link: '/portfolio-management/list-credits',
        parentId: 800,
        permissionRequired: 'show.AdminCartera',
      },
      {
        id: 805,
        label: 'Mi cartera promotor',
        link: '/portfolio-management/my-portfolio-promoter',
        parentId: 800,
        permissionRequired: 'show.MyPortfolio',
      },
      {
        id: 806,
        label: 'Mi cartera asesor V2',
        link: '/portfolio-management/my-portfolio-promoter-v2',
        parentId: 800,
        permissionRequired: 'show.MyPortfolioV2',
      },
      {
        id: 807,
        label: 'Administración de despachos',
        link: '/portfolio-management/collection-agency',
        parentId: 800,
        permissionRequired: 'show.CollectionAgency',
      },
      {
        id: 808,
        label: 'Mi cartera gestor',
        link: '/portfolio-management/my-portfolio-manager',
        parentId: 800,
        permissionRequired: 'show.MyPortfolioManager',
      },
      {
        id: 809,
        label: 'Mi cartera gerente',
        link: '/portfolio-management/my-portfolio-business-manager',
        parentId: 800,
        permissionRequired: 'show.MyPortfolioBusinessManager',
      },
      {
        id: 810,
        label: 'Gestión cobranza',
        link: '/portfolio-management/collection-management',
        parentId: 800,
        permissionRequired: 'show.CollectionManagement',
      },
    ],
  },
  {
    id: 900,
    label: 'Agenda',
    icon: 'bx-calendar',
    permissionRequired: 'show.AgendaModule',
    subItems: [
      {
        id: 901,
        label: 'Agenda asesor',
        link: '/agenda-board/agenda-of-the-day',
        parentId: 900,
        permissionRequired: 'show.AgendaOfTheDay',
      },
      {
        id: 902,
        label: 'Medidores agenda asesor',
        link: '/agenda-board/agenda-meters',
        parentId: 900,
        permissionRequired: 'show.AgendaMeters',
      },
      {
        id: 903,
        label: 'Agenda calendario',
        link: '/agenda-board/agenda-schedule',
        parentId: 900,
        permissionRequired: 'show.AgendaSchedule',
      },
      {
        id: 904,
        label: 'Agenda gestor',
        link: '/agenda-board/agenda-manager',
        parentId: 900,
        permissionRequired: 'show.AgendaManager',
      },
    ],
  },
  {
    id: 1000,
    label: 'Dispersiones',
    icon: 'bx-money',
    permissionRequired: 'show.DispersionesModule',
    subItems: [
      {
        id: 1001,
        label: 'Por créditos',
        link: '/dispersions-board/list',
        parentId: 1000,
        permissionRequired: 'show.DispersionesLista',
      },
      {
        id: 1002,
        label: 'Por cashback',
        link: '/dispersions-board/cashback',
        parentId: 1000,
        permissionRequired: 'show.DispersionesCashback',
      },
      {
        id: 1003,
        label: 'Por dotación',
        link: '/dispersions-board/allowances',
        parentId: 1000,
        permissionRequired: 'show.Dispersions.Allowances',
      },
      {
        id: 1004,
        label: 'Depósitos STP',
        link: '/stp/deposits',
        parentId: 1000,
        permissionRequired: 'stp.Deposits.show',
      },
      {
        id: 1005,
        label: 'Transacciones pendientes',
        link: '/payments/pending-transactions',
        parentId: 1000,
        permissionRequired: 'payments.PendingTransactions.show',
      },
    ],
  },
  {
    id: 1100,
    label: 'PaSe',
    icon: 'bx-broadcast',
    permissionRequired: 'show.PaSe',
    subItems: [
      {
        id: 1101,
        label: 'Catálogo de Servicios',
        link: '/pase/service-catalog',
        parentId: 1100,
        permissionRequired: 'show.PaSeServicesCatalog',
      },
      {
        id: 1102,
        label: 'Transacciones',
        link: '/pase/transaction-report',
        parentId: 1100,
        permissionRequired: 'show.PaSeTransactionReport',
      },
    ],
  },
  {
    id: 1200,
    label: 'Sociales',
    icon: 'bx-laptop',
    permissionRequired: 'show.SocialesWeb',
    subItems: [
      {
        id: 1201,
        label: 'Listado prospecto',
        link: '/portal/listCreditoPortal',
        parentId: 1200,
        permissionRequired: 'show.ListadoProspectoWeb',
      },
      {
        id: 1202,
        label: 'Listado contacto portal',
        link: '/portal/listProspectoPortal',
        parentId: 1200,
        permissionRequired: 'show.ListadoContacto',
      },
      {
        id: 1203,
        label: 'Administrador Blog',
        link: '/portal/Blog',
        parentId: 1200,
        permissionRequired: 'show.AdminitsradorBlog',
      },
    ],
  },
  {
    id: 1300,
    label: 'Dashboards',
    icon: 'bxs-dashboard',
    permissionRequired: 'show.Dashboards',
    subItems: [
      {
        id: 1301,
        label: 'Info Maltia',
        link: '/dashboards/executive-board',
        parentId: 1300,
        permissionRequired: 'show.ExecutiveBoard',
      },
      {
        id: 1302,
        label: 'Atracción',
        link: '/dashboards/attraction',
        parentId: 1300,
        permissionRequired: 'show.Attraction',
      },
      {
        id: 1303,
        label: 'Comercial',
        link: '/dashboards/commercial-meter',
        parentId: 1300,
        permissionRequired: 'show.Dashboard.CommercialMeter',
      },
      {
        id: 1304,
        label: 'Tubería',
        link: '/dashboards/pipe-meter',
        parentId: 1300,
        permissionRequired: 'show.Dashboard.PipeMeter',
      },
      {
        id: 1305,
        label: 'Mensajes',
        link: '/dashboards/messages',
        parentId: 1300,
        permissionRequired: 'show.Dashboard.Messages',
      },
    ],
  },
  {
    id: 1400,
    label: 'Recompensas Maltia',
    icon: 'bx-award',
    permissionRequired: 'show.Rewards',
    subItems: [
      {
        id: 601,
        label: 'Premios',
        link: '/rewards/awards',
        parentId: 600,
        permissionRequired: 'show.Rewards.Awards',
      },
      {
        id: 1401,
        label: 'Dotaciones',
        link: '/rewards/allocations',
        parentId: 1400,
        permissionRequired: 'show.Rewards.Allocations',
      },
      {
        id: 1402,
        label: 'Estados recompensas',
        link: '/rewards/rewards',
        parentId: 1400,
        permissionRequired: 'show.Rewards.RewardsStatuses',
      },
    ],
  },
  {
    id: 1600,
    label: 'El zorro',
    icon: 'bxl-firefox',
    permissionRequired: 'show.Fox',
    subItems: [
      {
        id: 1601,
        label: 'Reporte de pagos',
        link: '/fox/payment-report',
        parentId: 1600,
        permissionRequired: 'show.FoxPayments',
      },
      {
        id: 1602,
        label: 'Resumen histórico',
        link: '/fox/pivot-payment-report',
        parentId: 1600,
        permissionRequired: 'show.FoxPivotPayments',
      },
      {
        id: 1603,
        label: 'Reporte de comisiones',
        link: '/fox/commissions-report',
        parentId: 1600,
        permissionRequired: 'show.FoxCommissionsReport',
      },
      {
        id: 1604,
        label: 'Tokens',
        link: '/fox/tokens',
        parentId: 1600,
        permissionRequired: 'show.FoxTokens',
      },
      {
        id: 1605,
        label: 'Sucursales',
        link: '/fox/branches',
        parentId: 1600,
        permissionRequired: 'show.FoxBranches',
      },
    ],
  },
  {
    id: 1700,
    label: 'Configuraciones',
    icon: 'bx-cog',
    // link: '/settings/background-tasks',
    // parentId: 1700,
    permissionRequired: 'show.SettingsModule',
    subItems: [
      {
        id: 1701,
        label: 'Tareas en segundo plano',
        icon: 'bx-cog',
        link: '/settings/background-tasks',
        permissionRequired: 'show.BackgroundTasks',
        parentId: 1700,
      },
    ],
  },
  {
    id: 1500,
    label: 'Roles y permisos',
    icon: 'bx-lock',
    permissionRequired: 'show.RolesPermisos',
    subItems: [
      {
        id: 1501,
        label: 'Módulos',
        link: '/identity/modules',
        parentId: 1500,
        permissionRequired: 'show.Modulos',
      },
      {
        id: 1502,
        label: 'Permisos',
        link: '/identity/permissions',
        parentId: 1500,
        permissionRequired: 'show.Permisos',
      },
      {
        id: 1503,
        label: 'Roles',
        link: '/identity/roles',
        parentId: 1500,
        permissionRequired: 'show.Roles',
      },
      {
        id: 1504,
        label: 'Usuarios y roles',
        link: '/identity/users-roles',
        parentId: 1500,
        permissionRequired: 'show.UsuariosRoles',
      },
    ],
  },
];
